import { useDesignMaxTheme } from "@/packages";
import { AMENITY_GROUP, usePensionNameValue } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Flex, Image, Text } from "@chakra-ui/react";

export const RoomDesc = ({ room }: { room: RoomType }) => {
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const activeAmenities = AMENITY_GROUP.filter(
        ({ name }) => room.amenity_icon[name as keyof typeof room.amenity_icon],
    );
    return (
        <Flex
            maxW="688px"
            w="100%"
            flexDir="column"
            p={isMobile ? "0" : "40px 80px 0 0"}
            gap={isMobile ? "16px" : "24px"}
        >
            <Box>
                <Text {...FONT("cormorant", 36, 300, 1.2)}>{pensionName.eng.toUpperCase()}</Text>
                <Text {...FONT("cormorant", 56, 700, 1.2)}>ROOMS</Text>
            </Box>
            <Flex
                position="relative"
                maxW="720px"
                w="100%"
                flexDir="column"
                rowGap={isMobile ? "12px" : "16px"}
                sx={{
                    "& div > p:first-of-type": {
                        color: "#3b6c8d",
                        marginBottom: "8px",
                        ...FONT("notoSerif", 14, 400, 1.4),
                    },
                    "& div > p:nth-of-type(2)": {
                        color: "#6b6b6b",
                        ...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4),
                    },
                    "& div:last-of-type > p:nth-of-type(2)": {
                        ...FONT("pretendard", 14, 300, 1.4),
                        color: "#333",
                    },
                    "& > div:first-of-type > p:first-of-type": {
                        ...FONT("notoSerif", isMobile ? 16 : 24, 400, 1.4),
                    },
                }}
            >
                <Box>
                    <Text>{room.room_name}</Text>
                    <Text mt="16px" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                        객실설명
                    </Text>
                    <Text>{room.room_intro}</Text>
                </Box>
                <Box>
                    <Text>Room Type</Text>
                    <Text> {room.room_type}</Text>
                </Box>
                <Box>
                    <Text>Number of People</Text>
                    <Text>{`기준 ${room.people.min}인 ~ 최대 ${room.people.max}인`}</Text>
                </Box>
                <Box>
                    <Text>Size</Text>
                    <Text>{`${room.room_size}㎡`}</Text>
                </Box>
                <Box>
                    <Text>Facilities</Text>
                    <Flex mt="8px">
                        {activeAmenities.map(({ name, url }) => (
                            <Box
                                key={name}
                                w="48px"
                                h="48px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius="md"
                                bg="rgba(255,255,255,0.1)"
                            >
                                <Image src={url} alt={name} w="100%" h="100%" objectFit="contain" />
                            </Box>
                        ))}
                    </Flex>
                    <Text mt="8px">{room.amenity}</Text>
                </Box>
            </Flex>
        </Flex>
    );
};
